import styled, { css, ThemeProps } from 'styled-components';
import { Theme, ThemeColors } from '../theme';
import { media } from '../theme/base/mixins';
import { Content } from './Content';
import { Column } from './Grid';

export const SectionHeader = styled.div`
  margin: 0 auto 30px;
  max-width: ${(props: ThemeProps<Theme>) => props.theme.grid.maxWidth}px;
  padding-left: ${(props: ThemeProps<Theme>) => props.theme.grid.columnGap}px;
  padding-right: ${(props: ThemeProps<Theme>) => props.theme.grid.columnGap}px;

  ${media.large`
    margin-bottom: 40px;
  `}

  ${media.xlarge`
    margin-bottom: 70px;
  `};
`;

export interface SectionProps {
  bg?: keyof ThemeColors;
  full?: boolean;
  noPadding?: boolean;
  fullWidthSectionHeader?: boolean; // This is a bit ugly to allow SectionHeader/ContentHeader within a grid column #47033
}

export const Section = styled.section<SectionProps>`
  position: relative;
  background-color: ${(props) =>
    props.bg ? props.theme.colors[props.bg] : 'transparent'};

  margin: 0 auto;

  ${props =>
    !!props.full
      ? css`
          max-width: 100%;
        `
      : css`
          max-width: ${props.theme.grid.maxWidth}px;
          padding-left: ${props.theme.grid.columnGap}px;
          padding-right: ${props.theme.grid.columnGap}px;
        `} & & {
    padding-left: 0;
    padding-right: 0;
    margin: 0;
  }

  ${SectionHeader} {
    ${(props) => !props.fullWidthSectionHeader ? 'max-width: inherit;' : ''}
    padding-left: 0;
    padding-right: 0;
  }

  ${Content} & {
    padding-bottom: ${props => (props.noPadding ? '0' : '60px')};

    ${media.xlarge`
      padding-bottom: ${props => (props.noPadding ? '0' : '80px')};
    `};
  }

  //search result page
  ${Column} {
    ${media.large`
      .large-flex-container.large-flex-dir-column {
        height: 100%;
      }
    `};
  }
`;
